module.exports = __webpack_public_path__ + "static/img/it4d-e-samu_.84490f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/it4d-e-samu_.png
// module id = 04xm
// module chunks = 4